export const availableMarkets = [
  {
    name: 'Azerbaijan',
    value: 'AZ'
  },
  {
    name: 'Belarus',
    value: 'BY'
  },
  {
    name: 'Belgium',
    value: 'BE'
  },
  {
    name: 'Bosnia and Herzegovina',
    value: 'BA'
  },
  {
    name: 'Bulgaria',
    value: 'BG'
  },
  {
    name: 'Cambodia',
    value: 'KH'
  },
  {
    name: 'Canada',
    value: 'CA'
  },
  {
    name: 'China',
    value: 'CN'
  },
  {
    name: 'Norway',
    value: 'NO'
  },
  {
    name: 'Cyprus',
    value: 'CY'
  },
  {
    name: 'Croatia',
    value: 'HR'
  },
  {
    name: 'Denmark',
    value: 'DK'
  },
  {
    name: 'Estonia',
    value: 'EE'
  },
  {
    name: 'Finland',
    value: 'FI'
  },
  {
    name: 'France',
    value: 'FR'
  },
  {
    name: 'Germany',
    value: 'DE'
  },
  {
    name: 'Greece',
    value: 'GR'
  },
  {
    name: 'Hong Kong',
    value: 'HK'
  },
  {
    name: 'Hungary',
    value: 'HU'
  },
  {
    name: 'India',
    value: 'IN'
  },
  {
    name: 'Ireland',
    value: 'IE'
  },
  {
    name: 'Italy',
    value: 'IT'
  },
  { name: 'Kazakhstan', value: 'KZ' },
  { name: 'Laos', value: 'LA' },
  {
    name: 'Latvia',
    value: 'LV'
  },
  {
    name: 'Lithuania',
    value: 'LT'
  },
  { name: 'Malaysia', value: 'MY' },
  { name: 'Myanmar', value: 'MM' },
  { name: 'Montenegro', value: 'ME' },
  { name: 'Nepal', value: 'NP' },
  {
    name: 'Poland',
    value: 'PL'
  },
  {
    name: 'Vietnam',
    value: 'VN'
  },
  {
    name: 'Global',
    value: 'HQ'
  },
  {
    name: 'Serbia',
    value: 'RS'
  },
  {
    name: 'Singapore',
    value: 'SG'
  },
  {
    name: 'Sweden',
    value: 'SE'
  },
  {
    name: 'Switerland',
    value: 'CH'
  },
  {
    name: 'United Kingdom',
    value: 'GB'
  },
  {
    name: 'Switzerland',
    value: 'CH'
  },
  {
    name: 'Ukraine',
    value: 'UA'
  },
  {
    name: 'Vietnam',
    value: 'VN'
  }
];
